import React, { useCallback } from 'react';
import styled from 'styled-components/macro';
import { motion } from 'framer-motion';
import { useNomenclator } from '../../contexts/nomenclatorContext.js';
import { nombreEleccion } from '../../resources/constantes.json';
import LinkWithTop from '../Links/LinkWithTop.js';
import { useMesa } from '../../contexts/viewContext.js';
const transition = { staggerChildren: 0.1, duration: 0.2 };

const v = {
  open: {
    translateX: '0%',
    opacity: 1,
  },
  closed: {
    translateX: '-200%',
    opacity: 0,
  },
};

const Expand = ({ open, setOpen }) => {
  const { setMesa } = useMesa();
  const onLinkClick = useCallback(() => {
    setOpen(false);
    setMesa(null);
  }, [setMesa, setOpen]);
  const nomenclator = useNomenclator();

  const defaultElecCode = nomenclator.ordAmbitos[0];
  const defaultElecName = nombreEleccion[defaultElecCode];

  const elecciones = nomenclator.ordAmbitos.map(elec => nombreEleccion[elec]);

  return (
    <Ul
      variants={{
        open: { transition },
        closed: {
          transition: {
            ...transition,
            staggerDirection: -1,
          },
        },
      }}
      transition={transition}
    >
      <ListItem>
        <Link
          tabIndex={!open ? -1 : undefined}
          onClick={onLinkClick}
          to="/inicio"
        >
          INICIO
        </Link>
      </ListItem>
      <ListItem>
        <ListSeparator />
      </ListItem>
      {elecciones.map(elec => (
        <ListItem key={elec}>
          <Link
            tabIndex={!open ? -1 : undefined}
            onClick={onLinkClick}
            to={`/${elec}/0/colombia`}
          >
            {elec.toUpperCase()}
          </Link>
        </ListItem>
      ))}
      <ListItem>
        <ListSeparator />
      </ListItem>
      <ListItem>
        <Link
          tabIndex={!open ? -1 : undefined}
          onClick={onLinkClick}
          to={`/estadisticas/${defaultElecName}`}
        >
          ESTADISTICAS
        </Link>
      </ListItem>
    </Ul>
  );
};

const Ul = styled(motion.ul)`
  width: 40rem;
`;

const ListItem = styled(props => <motion.li variants={v} {...props} />)`
  color: #215ccc;
  font-size: 3rem;
  margin-bottom: 3rem;
`;

const ListSeparator = styled.div`
  height: 4px;
  margin: 3rem;
  background-color: #d8dfea;
`;

const Link = styled(LinkWithTop)`
  color: #164192;
  font-weight: 600;
`;

export default Expand;
